import { Button } from 'components/atoms';
import { useStoreState } from 'providers/StoreStateContext';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PiCaretDownBold } from 'react-icons/pi';
import { useLocation, useNavigate } from 'react-router-dom';
import { useGetLicenceConfiguration } from 'services/settings/individual';
import { INavbarItem } from 'types/navbar/navbar.interface';
import { settingsNavbarItems } from 'utils/navbar/navbarSettingsItems';
import './SettingsNavbar.scss';

const SettingsNavbar = () => {
  const [showChildren, setShowChildren] = useState<Record<string, boolean>>({});
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const { tokenData } = useStoreState();

  const license = useGetLicenceConfiguration();

  const customStyle = {
    justifyContent: 'center',
  };

  const getActiveTab = (pathname: string | undefined, item: any) => {
    if (pathname === '/settings' && item?.path === 'settings') {
      return true;
    }
    if (
      pathname?.startsWith('/settings/') &&
      pathname?.includes(item?.path) &&
      item?.path !== 'settings'
    ) {
      return true;
    }
    return false;
  };

  const toggleChildren = (key: string) => {
    setShowChildren(prev => ({ ...prev, [key]: !prev[key] }));
  };

  const navigateToPath = (item: INavbarItem, key: string) => {
    if (item.children) {
      toggleChildren(key);
    } else {
      navigate(`/${item.path}`);
    }
  };

  return (
    <div className='settingsNavbar-wrapper'>
      <div className='buttons'>
        {settingsNavbarItems({
          isDemo: license.data?.isDemo,
          clientUserAvailable: license.data?.clientModuleAccess,
        }).map((item, key) =>
          item.permissionNames &&
          tokenData &&
          !item.permissionNames?.find(
            name => tokenData[name as keyof typeof tokenData]
          ) ? null : (
            <div
              key={key}
              className={` opacity-80 button-wrapper ${
                showChildren[key] ? 'show-sub-menu' : ''
              }`}>
              <Button
                isClear
                buttonStyle={customStyle}
                fullWidth
                isActive={getActiveTab(pathname, item)}
                onClick={() => navigateToPath(item, key.toString())}
                className={`button`}>
                <div className='flex gap-4 w-full '>
                  <Button.Icon icon={<item.icon />} />
                  <Button.Text
                    text={
                      item.name === 'demo'
                        ? 'DEMO'
                        : t(`navbar.${item.name ?? item.path}`)
                    }
                  />

                  {item.children && (
                    <Button.Icon
                      icon={
                        <PiCaretDownBold
                          className={`menu-arrow ${
                            showChildren[key] ? 'rotated' : ''
                          }`}
                        />
                      }
                    />
                  )}
                </div>
              </Button>

              {item.children && showChildren[key] && (
                <div className='sub-menu'>
                  {item.children.map((child, childKey) =>
                    child.permissionNames &&
                    tokenData &&
                    !child.permissionNames?.find(
                      name => tokenData[name as keyof typeof tokenData]
                    ) ? null : (
                      <Button
                        key={childKey}
                        isClear
                        buttonStyle={customStyle}
                        fullWidth
                        isActive={pathname.startsWith(`/${item.path}`)}
                        onClick={() => navigate(`/${child.path}`)}
                        className='button child-button'>
                        <div className='flex gap-4 w-full'>
                          <Button.Icon icon={<child.icon />} />
                          <Button.Text
                            text={t(`navbar.${child.name ?? child.path}`)}
                          />
                        </div>
                      </Button>
                    )
                  )}
                </div>
              )}
            </div>
          )
        )}
        <div className='extender' />
      </div>
    </div>
  );
};

export default SettingsNavbar;
